import { parsePath } from "history";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";

import { Alert, Box, Button, Heading, Link, Stack } from "@seneca/senekit";

import ControlledTextInput from "seneca-common/utils/form-hook/inputs/ControlledTextInput";
import { validateControlledEmailLoosely } from "seneca-common/utils/form-hook/utils/validationFunctions";

import getAppName from "features/plurall/utils/getAppName";
import { linkToSignIn } from "features/sign-up/links";

export function ConfirmEmailForm({
  onSubmit,
  errorMessage
}: {
  onSubmit: (email: string) => void;
  errorMessage: string | undefined;
}) {
  const form = useForm<{ email: string }>();
  const location = useLocation();

  const pageReferrer = new URLSearchParams(location.search).get("pageReferrer");
  const returnLink = pageReferrer ? parsePath(pageReferrer) : linkToSignIn();

  const onSubmitClick: SubmitHandler<{ email: string }> = async ({ email }) => {
    onSubmit(email);
  };

  return (
    <FormProvider {...form}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="100%"
      >
        <Box marginBottom="xlarge">
          <Stack space="xxlarge">
            <Heading level="3" align="center">
              Confirm your email
            </Heading>

            {!!errorMessage && (
              <Alert tone="error" iconName="exclamationCircle">
                {errorMessage}
              </Alert>
            )}

            <ControlledTextInput
              name="email"
              label="Email"
              type="email"
              validateObj={validateControlledEmailLoosely}
            />
          </Stack>
        </Box>

        <Box marginTop="xlarge">
          <Stack space="xlarge" align="center">
            <Button
              width="100%"
              onClick={form.handleSubmit(onSubmitClick)}
              loading={form.formState.isSubmitting}
            >
              Continue to {getAppName()}
            </Button>

            {!!errorMessage && (
              <Link to={returnLink}>Continue another way</Link>
            )}
          </Stack>
        </Box>
      </Box>
    </FormProvider>
  );
}
